import type { OnboardingStep } from "@/api/onboarding";

const LOCKED_TOP_LOGO_ONBOARDING_STEPS = new Set<OnboardingStep | null>([
  null,
  "desktop_intro",
  "desktop_permissions",
  "desktop_perm_voice_quality",
  "desktop_perm_voice",
  "desktop_perm_hotkeys",
  "desktop_perm_vision",
  "desktop_usage_primer",
]);

export function isTopLogoOnboardingLocked({
  step,
  stepHydrated,
}: {
  step: OnboardingStep | null;
  stepHydrated: boolean;
}): boolean {
  if (stepHydrated === false) return true;
  if (stepHydrated !== true) return false;
  return LOCKED_TOP_LOGO_ONBOARDING_STEPS.has(step);
}
